export enum IntegrationType {
  OpenAI = 1,
  Hubspot = 2,
}

export interface Integration {
  id: IntegrationType;
  title: string;
  type: string;
  description: string;
  is_connected: boolean;
}

export enum StatusHubpspot {
  NotIntegrated = 0,
  Integrated = 1,
  ToUpdate = 2,
  Disconnected = 3,
}

export interface Functionality {
  id: number
  name: string
  details: string[]
}

export interface IntegrationData {
  permission: string
  permission_optional: string
  state: number
  status: number
  created_at: string
  updated_at: string
  functionalities: Functionality[]
}

export interface HubspotEventPayload {
  id?: number;
  scheduled: string | null;
  contacts: number[];
  portfolios: number[];
  entities?: number[];
  state?: StatusHubpspotEvent;
}

export interface HubspotFunctionalityPayload {
  active?: boolean;
  code: string;
  mode: number;
  events: HubspotEventPayload[];
}

export interface HubspotSingleEventPayload {
  code: string; // tipo de funcionalidad (EXPORT_CONTACTS, IMPORT_CONTACTS, etc)
  event: {
    id?: number;
    scheduled?: string | null;
    contacts?: number[];
    portfolios?: number[];
    entities?: number[];
  };
}

export enum StatusHubpspotEvent {
  Programmed = 1,
  InProgress = 2,
  Finished = 3,
  Canceled = 4,
}

export const StatusHubpspotEventLabel: Record<StatusHubpspotEvent, string> = {
  [StatusHubpspotEvent.Programmed]: 'Programado',
  [StatusHubpspotEvent.InProgress]: 'En curso',
  [StatusHubpspotEvent.Finished]: 'Finalizado',
  [StatusHubpspotEvent.Canceled]: 'Cancelado',
};

export const StatusHubpspotEventColor: Record<StatusHubpspotEvent, string> = {
  [StatusHubpspotEvent.Programmed]: 'default',
  [StatusHubpspotEvent.InProgress]: 'orange',
  [StatusHubpspotEvent.Finished]: 'green',
  [StatusHubpspotEvent.Canceled]: 'red',
};